module.exports = __webpack_public_path__ + "static/img/img01.1385eb5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv011/img01.gif
// module id = ho2P
// module chunks = 0